/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import ReconnectSocialModal from 'app/components/ReconnectModal/ReconnectSocialModal.jsx';

class SocialDisconnectBanner extends React.Component {
    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);

    }

    componentDidMount() {

        // if (dataLayer) {
        //     dataLayer.push({
        //         'event': 'promotionView',
        //         'ecommerce': {
        //             'promoView': {
        //                 'promotions': [
        //                     {
        //                         'id': 'socialdisconnect_banner',
        //                         'name': 'Social Disconnect Banner',
        //                         'creative': 'socialdisconnect_banner.1',
        //                         'position': 'top-promo-bar'
        //                     }
        //                 ]
        //             }
        //         },
        //         //GA 4 params
        //         'promotion_id': 'socialdisconnect_banner',
        //         'promotion_name': 'Social Disconnect Banner',
        //         'creative_name': 'socialdisconnect_banner.1',
        //         'creative_slot': 'top-promo-bar'
        //     });
        // }

        if (gtag) {
            gtag('event', 'view_promotion', {
                'promotion_id': 'socialdisconnect_banner',
                'promotion_name': 'Social Disconnect Banner',
                'creative_name': 'socialdisconnect_banner.1',
                'creative_slot': 'top-promo-bar',
                items: [
                    {
                        item_id: 'dlvrit_1',
                        item_name: 'dlvr.it premium plan',
                        price: 1.00,
                        quantity: 1
                    }
                ]
            });
        }

        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Banner View',
                event_data: {
                    banner: 'Social Disconnect Banner'
                }
            });
        }

        // load notices
        this.props.getNotices();

    }

    onClick(e) {

        let that = this;

        e.preventDefault();

        // if (dataLayer && window.ga && ga.loaded) {
        //     dataLayer.push({
        //         'event': 'promotionClick',
        //         'ecommerce': {
        //             'promoClick': {
        //                 'promotions': [
        //                     {
        //                         'id': 'socialdisconnect_banner',
        //                         'name': 'Social Disconnect Banner',
        //                         'creative': 'socialdisconnect_banner.1',
        //                         'position': 'top-promo-bar'
        //                     }
        //                 ]
        //             }
        //         },
        //         //GA 4 params
        //         'promotion_id': 'socialdisconnect_banner',
        //         'promotion_name': 'Social Disconnect Banner',
        //         'creative_name': 'socialdisconnect_banner.1',
        //         'creative_slot': 'top-promo-bar',
        //         items: [
        //             {
        //                 item_id: 'dlvrit_1',
        //                 item_name: 'dlvr.it premium plan',
        //                 price: 1.00,
        //                 quantity: 1
        //             }
        //         ]
        //     });
        // }

        if (gtag) {
            gtag('event', 'select_promotion', {
                'promotion_id': 'socialdisconnect_banner',
                'promotion_name': 'Social Disconnect Banner',
                'creative_name': 'socialdisconnect_banner.1',
                'creative_slot': 'top-promo-bar',
                items: [
                    {
                        item_id: 'dlvrit_1',
                        item_name: 'dlvr.it premium plan',
                        price: 1.00,
                        quantity: 1
                    }
                ]
            });

            this.props.persistData('gaPromo', {
                'promotion_id': 'socialdisconnect_banner',
                'promotion_name': 'Social Disconnect Banner',
            });
        }

        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Banner Click',
                event_data: {
                    banner: 'Social Disconnect Banner'
                }
            });
        }

        let reconnectModal = (
            <ReconnectSocialModal
                {...this.props}
                setModal={this.props.closeAllModals}
                socialNotices={this.props.app.statuses.socialsDisconnected}/>
        );

        this.props.addModal(reconnectModal)

    }

    render() {
        return (
            <div>
                <div className="icon-wrapper">
                    <i className="icon ion-information-circled"/>
                </div>
                <span>We can’t post to some of your socials. <a href="#" onClick={this.onClick}>Reconnect to resume posting</a></span>
            </div>
        );
    }

};

SocialDisconnectBanner.displayName = "SocialDisconnectBanner";

export default SocialDisconnectBanner;
